import { defineHierarchyChart } from '@rdrive/helper-chart-config';
import { ITEMS_CHART, ITEM_TEMPLATES, CATEGORIES, STATUS_LEVEL } from './itemsHierarchy.js';

// Item breakdown by category -> subcategory -> template -> status, for the Controllers page's
// StackedHorizontalBarChart (@rdrive/plugin-chart-stacked-bar). Since IA_ABSORPTION_PLAN Phase 5
// steps 5.2–5.4 a level table on `defineHierarchyChart` (@rdrive/helper-chart-config) — the
// generated queries equal the old hand-written ones (tooling/parity/hierarchy-chart/) but for one
// named difference, SELECT_ORDER: the old subcategory query listed `title` before `parentId`, the
// generated one lists `parentId` first (the chart reads its columns by name). Every filter value
// goes through escapeSql (rule 6).
//
// Scoping: the drill scope ('andIdIn', ./itemsHierarchy.js) keeps a status click inside the level
// the user navigated into.

export function useControllerCategoryChart({ chartName, filterContext, conn }) {
  return defineHierarchyChart({
    chartName,
    filterContext,
    conn,
    ...ITEMS_CHART,
    defaults: { value: 'window' },
    levels: [
      {
        level: 'category', titleKey: 'category',
        id: 'c.id', title: 'c.title', joins: [ITEM_TEMPLATES, CATEGORIES],
        filter: { joins: [ITEM_TEMPLATES], where: [['it.categoryId', 'id']] },
      },
      // The 'subcategory' level lists the category's item templates (parent: the category) and
      // filters by profile, as the template level does
      {
        level: 'subcategory', titleKey: 'subcategory',
        id: 'it.id', parentId: 'c.id', title: 'it.title', joins: [ITEM_TEMPLATES, CATEGORIES],
        groupBy: 'it.id, it.title, c.id, s.title, s.color', partitionBy: 'it.id, it.title, s.title, s.color',
        filter: { where: [['i.profileId', 'id']] },
      },
      {
        level: 'template', titleKey: 'template',
        id: 'i.profileId', title: 'it.title', joins: [ITEM_TEMPLATES],
        filter: { where: [['i.profileId', 'id']] },
      },
      STATUS_LEVEL,
    ],
  });
}
